import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Box,
} from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import dayjs from 'dayjs';

interface ResponsiveCardProps {
  number: number;
  date: number;
  region: string;
  details: string;
  onViewDetails: () => void;
  type: string;
}

const ResponsiveCard: React.FC<ResponsiveCardProps> = ({
  number,
  date,
  region,
  onViewDetails,
  details,
  type,
}) => {
  return (
    <Card
      sx={{
        // maxWidth: 400,
        width: '99%',
        mx: 'auto',
        my: 2,
        // p: 2,
        borderRadius: 2,
        boxShadow: 2,
      }}>
      {/* Top Section: Number & Button */}
      <CardContent
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          // pb: 1,
        }}>
        <Typography fontSize={15} fontWeight="bold">
          {number}
        </Typography>

        {/* <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={onViewDetails}>
          View Details
        </Button> */}
        <span
          style={{
            fontSize: 13,
            color: 'rgba(2, 105, 93, 1)',
            fontWeight: 'bold',
          }}
          onClick={onViewDetails}>
          {type == 'REQUESTED'
            ? 'View Request'
            : 'View Report'}
          <ArrowRightIcon />
        </span>
      </CardContent>

      {/* Divider */}
      <Divider />

      {/* Bottom Section: Date & Region */}
      <CardContent
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap', // Allows wrapping if needed
          pt: 1,
        }}>
        <Box>
          <Typography
            variant="caption"
            color="textSecondary"
            fontSize={11}>
            Sowing Date
          </Typography>
          <Typography
            variant="body1"
            fontSize={13}
            fontWeight={'bold'}>
            {date > 0
              ? dayjs(date ? date * 1000 : 0).format(
                  'DD/MM/YYYY'
                )
              : '-'}
          </Typography>
        </Box>

        <Box>
          <Typography
            variant="caption"
            color="textSecondary"
            fontSize={11}>
            Village
          </Typography>
          <Typography
            variant="body1"
            fontSize={13}
            textTransform={'capitalize'}
            fontWeight={'bold'}>
            {region}
          </Typography>
        </Box>

        {/* ✅ New Section Below */}
        <Box
          sx={{
            width: '100%', // Makes it full width
            mt: 2, // Adds spacing from the above section
            p: 1,
            backgroundColor: 'rgba(239, 245, 246, 1)', // Light green background
            borderRadius: 1,
          }}>
          <Typography
            variant="body1"
            fontSize={13}
            noWrap
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '100%', // Ensures it doesn't exceed container width
            }}>
            {details}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ResponsiveCard;
